import React from 'react'
import { Typography, Card } from 'antd'
import ModalImage from "react-modal-image";
import {Link} from 'gatsby';
import LandingLayout from '@layouts/LandingLayout'


export default () => (
  <LandingLayout activeTab = '2'>
    <div className='flex flex-col items-start'>
    <Typography.Title className='text-primary-color'>
        SecureT - personal encryption made easy
      </Typography.Title>
    <div className="p-2 col-md-12 mt-4">
        <Link to='/projects/securet/privacy'>
      <button type='button' className="btn btn-dark">Privacy policy</button>
            </Link>
            &nbsp;&nbsp;
        <Link to='/projects/securet/tos'>
      <button type='button' className="btn btn-dark">Terms and Conditions</button>
            </Link>
        </div>
        <br/>
     <Card 
     style={{ width: '100%' }}
     title="Dev Notes: First Release"
     extra={<Link to="/projects/securet/1">Read more</Link>}
     >
     Aug 5, 2020 <br/> This is the first release for this app. I intended this app to be a simple 
     experement but I hope that it will be impactful.  
     </Card>
    </div>
  </LandingLayout>
)
